import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyCNaWRJ6-Mdcon-pyz8-NWJpQC6Qf-2MDw",
    authDomain: "copybuddyio.firebaseapp.com",
    projectId: "copybuddyio",
    storageBucket: "copybuddyio.appspot.com",
    messagingSenderId: "14125146877",
    appId: "1:14125146877:web:aff9d71ce14876f7579494",
    measurementId: "G-TJMM4YYEXJ"
  };

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };